import React from 'react';
import classnames from 'classnames';
import './row.scss';

interface Props extends PropsWithClassNameRequired {
  isSelected: boolean;
}

const Row = ({className, isSelected, ...rest}: Props) => {
  return (
    <tr
      className={classnames('o-table__row', className, {
        'o-table__row--selected': isSelected
      })}
      {...rest}
    />
  );
};

export default Row;
